import type { KeyboardEvent } from "react";

/** Blocks Enter from implicitly submitting a form (textarea/button/select exempt). */
export function preventImplicitSubmitOnEnter(
  event: KeyboardEvent<HTMLElement>,
) {
  if (event.key !== "Enter" || event.nativeEvent.isComposing) {
    return;
  }

  const target = event.target;
  if (
    target instanceof HTMLTextAreaElement ||
    target instanceof HTMLButtonElement ||
    target instanceof HTMLSelectElement
  ) {
    return;
  }

  if (
    target instanceof HTMLInputElement &&
    (target.type === "submit" || target.type === "button")
  ) {
    return;
  }

  event.preventDefault();
}
